export { default } from './Slide';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Slide/index.js
// module id = 178
// module chunks = 0